import React, { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const title = "Creative Control";

const maxValue = 1;
const CreativeControl = ({ value, setValue, options }) => {
    const [showInfo, setShowInfo] = useState(false);

    return (
        <div className="mb-8">
            <div className="flex items-center gap-2 mb-3">
                <label className="block text-gray-700 font-semibold text-sm tracking-wide">{title}</label>
                <button
                    onClick={() => setShowInfo(!showInfo)}
                    className="text-gray-400 hover:text-purple-500 transition-all duration-300 transform hover:scale-110"
                >
                    <FaInfoCircle size={16} />
                </button>
            </div>

            {showInfo && (
                <div className="mb-4 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 border-l-4 border-purple-500 rounded-md shadow-md w-full transition-all duration-200">
                    <div className="space-y-4">
                        <div className="space-y-3">
                            {options.map((option, index) => (
                                <div key={index} className="flex items-start gap-2">
                                    <div className="w-2 h-2 rounded-full bg-purple-500 mt-1.5 flex-shrink-0"></div>
                                    <div>
                                        <p className="font-semibold text-purple-600">{option.value === 0 ? "Mode 1" : "Mode 2"}</p>
                                        <p className="text-gray-700 text-sm leading-relaxed">{option.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <div className="relative bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                <input
                    type="range"
                    min="0"
                    max={maxValue}
                    value={value}
                    onChange={(e) => setValue(parseInt(e.target.value))}
                    step="1"
                    className="mx-2 w-full h-1.5 bg-gray-100 rounded-full appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-[#4B3BFF] [&::-webkit-slider-thumb]:shadow-lg [&::-webkit-slider-thumb]:transition-all [&::-webkit-slider-thumb]:duration-200 [&::-webkit-slider-thumb]:hover:scale-110 [&::-webkit-slider-thumb]:hover:shadow-xl"
                    style={{
                        background: `linear-gradient(to right, #4B3BFF ${(value / maxValue) * 100}%, #E5E7EB ${(value / maxValue) * 100}%)`,
                        width: "95%",
                    }}
                />
                <div className="flex justify-between mt-2">
                    {options.map((option, index) => (
                        <div
                            key={index}
                            className={`flex flex-col items-center transition-all duration-300 ${value === option.value ? 'text-[#4B3BFF] scale-110' : 'text-gray-400'}`}
                            onClick={() => setValue(option.value)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className={`${value === option.value ? 'bg-[#4B3BFF] scale-125' : 'bg-gray-300'}`}></div>
                            <span className="text-xs font-medium tracking-wide flex flex-col items-center">
                                {option.value === 0 ? "Mode 1" : (<>Mode 2 {option.label !== "API 2" && <span className="text-[6px] text-gray-400">(Recommended)</span>}</>)}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CreativeControl;
